import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import FlightIcon from "@mui/icons-material/Flight";
import TrainIcon from "@mui/icons-material/Train";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

const FlightInfo = ({ flightData, handleOpenModal, textColor }) => {
	return (
		<Box
			className="template-item"
			data-template-item
			sx={{ marginTop: 1, padding: { xs: 0.5, sm: 1 } }}
			onClick={() => handleOpenModal(null)}
		>
			{flightData &&
				flightData.map((flight, index) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								marginBottom: index < flightData.length - 1 ? 2 : 0,
							}}
							key={index}
						>
							<Box
								sx={{
									padding: { xs: 1, sm: 1.25 },
									border: "1px solid rgba(0, 0, 0, 0.06)",
									borderRadius: { xs: "16px", sm: "20px" },
									display: "flex",
									flexDirection: "row",
									backgroundColor: "#fff",
									boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
									gap: { xs: 0.75, sm: 0 },
									alignItems: "center",
									justifyContent: "space-between",
									transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
									"&:hover": {
										boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
									},
								}}
							>
								{/* Origen - misma fila en móvil y escritorio */}
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: { xs: "flex-start", sm: "center" },
										justifyContent: "center",
										textAlign: { xs: "left", sm: "center" },
										padding: { xs: 0.25, sm: 1 },
										flex: { xs: "0 1 auto", sm: "0 0 auto" },
										minWidth: { xs: 0, sm: "120px" },
										overflow: "hidden",
									}}
								>
									<Typography
										variant="body1"
										sx={{
											fontWeight: 700,
											fontSize: { xs: "0.875rem", sm: "1.125rem" },
											color: "#1a1a2e",
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap",
										}}
									>
										{flight.departureAirport}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontSize: { xs: "0.75rem", sm: "0.9375rem" },
											color: "#4B5563",
											mt: 0.25,
										}}
									>
										{flight.departureDay}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontSize: { xs: "0.75rem", sm: "0.9375rem" },
											color: "#4B5563",
										}}
									>
										{flight.departureTime}
									</Typography>
								</Box>
								{/* Duración + icono - centro */}
								<Box
									sx={{
										flex: { xs: "0 0 auto", sm: 1 },
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
										textAlign: "center",
										padding: { xs: 0.25, sm: 1 },
										position: "relative",
									}}
								>
									<Typography
										variant="body2"
										sx={{
											color: "#4B5563",
											fontSize: { xs: "0.6875rem", sm: "0.8125rem" },
											mb: { xs: 0.25, sm: 1 },
											whiteSpace: "nowrap",
										}}
									>
										{flight.type === "flight"
											? "Duración del vuelo:"
											: "Duración del trayecto:"}{" "}
										{flight.duration}
									</Typography>
									{flight.type === "flight" ? (
										<FlightIcon
											sx={{
												fontSize: { xs: 20, sm: 26 },
												color: "#374151",
												transform: "rotate(90deg)",
												position: "relative",
												zIndex: 1,
												mb: { xs: 0, sm: -0.5 },
											}}
										/>
									) : flight.type === "train" ? (
										<TrainIcon
											sx={{
												fontSize: { xs: 20, sm: 26 },
												color: "#374151",
												position: "relative",
												zIndex: 1,
												mb: { xs: 0, sm: -0.5 },
											}}
										/>
									) : (
										<DirectionsCarIcon
											sx={{
												fontSize: { xs: 20, sm: 26 },
												color: "#374151",
												position: "relative",
												zIndex: 1,
												mb: { xs: 0, sm: -0.5 },
											}}
										/>
									)}
									<Divider
										sx={{
											width: "100%",
											mt: -2,
											borderColor: "rgba(0, 0, 0, 0.06)",
											position: "relative",
											zIndex: 0,
										}}
									/>
								</Box>
								{/* Destino - misma fila en móvil y escritorio */}
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: { xs: "flex-end", sm: "center" },
										justifyContent: "center",
										textAlign: { xs: "right", sm: "center" },
										padding: { xs: 0.25, sm: 1 },
										flex: { xs: "0 1 auto", sm: "0 0 auto" },
										minWidth: { xs: 0, sm: "120px" },
										overflow: "hidden",
									}}
								>
									<Typography
										variant="body1"
										sx={{
											fontWeight: 700,
											fontSize: { xs: "0.875rem", sm: "1.125rem" },
											color: "#1a1a2e",
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap",
										}}
									>
										{flight.arrivalAirport}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontSize: { xs: "0.75rem", sm: "0.9375rem" },
											color: "#4B5563",
											mt: 0.25,
										}}
									>
										{flight.arrivalDay}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontSize: { xs: "0.75rem", sm: "0.9375rem" },
											color: "#4B5563",
										}}
									>
										{flight.arrivalTime}
									</Typography>
								</Box>
							</Box>
							{flight.hasStopover && (
								<Box
									sx={{
										display: "flex",
										flexDirection: { xs: "column", sm: "row" },
										justifyContent: "center",
										alignItems: { xs: "stretch", sm: "center" },
										paddingTop: 1.5,
										paddingBottom: 0.5,
										gap: 1,
									}}
								>
									<Divider
										sx={{
											flex: 1,
											borderColor: "rgba(0, 0, 0, 0.06)",
											display: { xs: "none", sm: "block" },
										}}
									/>
									<Typography
										variant="body2"
										sx={{
											paddingLeft: { xs: 0, sm: 1 },
											paddingRight: { xs: 0, sm: 1 },
											fontSize: { xs: "0.8125rem", sm: "0.875rem" },
											color: "#4B5563",
											whiteSpace: { xs: "normal", sm: "nowrap" },
											textAlign: { xs: "left", sm: "center" },
										}}
									>
										Duración de la conexión: {flight.stopoverDuration}
									</Typography>
									<Divider
										sx={{
											flex: 1,
											borderColor: "rgba(0, 0, 0, 0.06)",
											display: { xs: "none", sm: "block" },
										}}
									/>
								</Box>
							)}
						</Box>
					);
				})}
		</Box>
	);
};

export default FlightInfo;
